import API, { API_URL } from 'api/API';

import { ApiResult, DateTime, WeatherData } from 'libs/types';
import { getUrlQueryString } from 'libs/utils';

interface GetWeatherDataApiParams {
  obsId: number;
  now: string;
  min: string;
}

export interface GetWeatherDataApiResult extends ApiResult {
  t_list: WeatherData[];
  h_list: WeatherData[];
  c_list: WeatherData[];
  w_list: WeatherData[];
  time_list: string[];
  min_max_mean_list: [number, number, number][];
  min_date_time: DateTime;
  latest_update_date_time: DateTime;
}

async function getWeatherDataApi({ obsId, now, min }: GetWeatherDataApiParams): Promise<GetWeatherDataApiResult> {
  const queryString = getUrlQueryString({
    obs_id: obsId,
    now,
    min,
  });
  const { data } = await API.get(`${API_URL.SKYW.GET_WEATHER_DATA}?${queryString}`);

  return data;
}

export default getWeatherDataApi;
